import {PrinterIcon} from '../../../partials/icons';
import {useShortcuts} from '../../../../../hooks/use-shortcuts';
import {useShippingStation} from '../../../../../hooks/use-session';
import {useTranslation} from '../../../../../hooks/use-translation';
import {blurAfterPointer} from '../../../../../helpers/focus';
import {setShippingStation} from '../../../../../helpers/session';

/**
 * The picked shipping station: the button (and F6, on the page's layer: not while a modal or the PIN prompt is open)
 * forgets it, and the terminal asks for a station again.
 */
const TopNavShippingStation = (): React.JSX.Element | null => {
    const t = useTranslation();
    const shippingStation = useShippingStation()?.shippingStation;

    useShortcuts({F6: () => setShippingStation(null)}, Boolean(shippingStation));

    if (!shippingStation) {
        return null;
    }

    return (
        <button
            type="button"
            className="button button-small"
            title={t('topNav.changeStation')}
            onClick={event => {
                blurAfterPointer(event);
                setShippingStation(null);
            }}
        >
            <PrinterIcon />
            {shippingStation}
            <kbd>F6</kbd>
        </button>
    );
};

export default TopNavShippingStation;
